t = require('views/internal/teacup-with-helpers')('board_menu_default')

powerUpNavigationItem = t.renderable ({ hasBCPowerUps, hasGoldPowerUps }) ->
  t.li '.board-menu-navigation-item', ->
    t.a '.board-menu-navigation-item-link.js-open-power-ups', { href: '#' }, ->
      t.icon 'power-up', 'power-ups', { class: 'board-menu-navigation-item-link-icon' }
      t.raw '&nbsp;'
      if hasBCPowerUps
        t.icon 'business-class', class: 'icon-business-class-color'
      else if hasGoldPowerUps
        t.icon 'trello-gold', { class: 'icon-trello-gold-color' }
      t.span '.board-menu-navigation-item-link-count.js-enabled-power-up-count'
      t.span '.board-menu-navigation-item-new.js-power-up-new', ->
        t.format 'new'
      t.span '.board-menu-navigation-item-link-warning.js-power-up-disable-timer'
      t.div '.board-menu-navigation-item-link-summary', ->
        t.raw '&nbsp;'
        t.format 'power-ups-explanation'

module.exports = t.renderable ({ hasBCPowerUps, hasGoldPowerUps, editable, inPowerUpSlotsExperiment }) ->

  t.p '.error.js-file-too-large', { style: 'margin: 12px 0 6px; display:none;' }, ->
    t.format 'file-too-large-10mb-limit'

  t.ul '.board-menu-navigation', ->

    if editable
      t.li '.board-menu-navigation-item.mod-background', ->
        t.a '.board-menu-navigation-item-link.js-change-background', { href: '#' }, ->
          t.span '.board-menu-navigation-item-link-icon.js-fill-background-preview'
          t.raw '&nbsp;'
          t.format 'change-background'

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-card-filter', { href: '#' }, ->
        t.icon 'filter', 'filter-cards', { class: 'board-menu-navigation-item-link-icon' }

    if editable && !inPowerUpSlotsExperiment
      powerUpNavigationItem({ hasBCPowerUps, hasGoldPowerUps })

    if editable
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-stickers', { href: '#' }, ->
          t.icon 'sticker', 'stickers', { class: 'board-menu-navigation-item-link-icon' }

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-more', { href: '#' }, ->
        t.icon 'overflow-menu-horizontal', 'more', { class: 'board-menu-navigation-item-link-icon' }

  if editable && inPowerUpSlotsExperiment
    t.hr()
    t.ul '.board-menu-navigation', ->
      powerUpNavigationItem({ hasBCPowerUps, hasGoldPowerUps })

    t.ul '.board-menu-navigation.js-power-up-slots'
    t.ul '.board-menu-navigation.js-power-up-upsell-slots'

  t.hr()

  t.a '.board-menu-section-header.js-open-activity', { href: '#' }, ->
    t.span '.board-menu-section-header-icon.icon-lg.icon-activity'
    t.span '.board-menu-section-header-title', ->
      t.format 'activity'
    t.span '.board-menu-section-header-count.js-unread-activity-count'

  t.div '.js-menu-action-list'

  t.a '.show-more.js-fill-activity-button.js-open-activity', { href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_default.coffee